<template>
  <div>
    <Header></Header>
    <div class="ui container">
      <div v-if="this.loading">
        <div class="ui active inverted dimmer">
          <div class="ui text loader">Loading</div>
        </div>
        <p></p>
      </div>
      <table v-else ref="recordsTable" id="example" class="ui celled table">
        <thead>
          <tr>
            <th>#</th>
            <th>Question</th>
            <th>Answer</th>
            <th>Agent</th>
            <th>Rating</th>
            <th>Modified</th>
            <th>Expires</th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr v-bind:key="key" v-for="(question, key) in this.questions">
            <td>{{ key }}</td>
            <td>
              <div class="table-text">
                <router-link :to="'/qaedit/' + question.q_id">{{
                  question.question
                }}</router-link>
              </div>
            </td>
            <td>
              <div class="table-text">{{ question.answer }}</div>
            </td>
            <td></td>
            <td>${{ question.rating }}</td>
            <td>{{ question.last_modified }}</td>
            <td>{{ question.expiry_date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "../components/Header";
const dt = null;
export default {
  name: "qarecord",
  components: { Header },
  data() {
    return {
      questions: [],
      loading: true
    };
  },
  methods: {
    async getRecords() {
      let response = await this.axios.post(
        this.$store.state.apiUrl + "Read/qarecords.php",
        {
          token: localStorage.getItem("token")
        }
      );
      this.questions = response.data.data;
      this.loading = false;
    }
  },
  beforeMount() {
    this.getRecords();
  },
  mounted() {
    this.dt = $(this.$refs.recordsTable).DataTable();
  },
  watch: {
    questions(val) {
      this.dt.destroy();
      this.$nextTick(() => {
        this.dt = $(this.$refs.recordsTable).DataTable();
      });
    }
  }
};
</script>

<style>
.table-text {
  white-space: nowrap;
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media only screen and (min-width: 1200px) {
  .ui.container.qarecords {
    margin-left: auto !important;
    max-width: 900px !important;
    margin-right: auto !important;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 992px) {
  .ui.container {
    max-width: 1150px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QARecords.vue